module.exports = __webpack_public_path__ + "img/energy-2.2.83cea849.svg";